import { Box, Button, Dialog, Divider, Stack, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { addOrEditModelAction, fileUploadTableOptions, storesLinkedTables } from "components/EboStoreV4/data";
import React, { useState } from "react";
import AddOrEditModal from "./AddOrEditModal/AddOrEditModal";
import { converAttrToDatagridCol } from "data/globalData";
import { grey } from "@mui/material/colors";
import { addFilesCol } from "components/EboStoreV4/CommonComponents/AddFiles/AddFiles";

function FileUploadTable({
	filesDetails,
	setFilesDetails,
	handleFileUploadDetails,
	createDetailsApi,
	handleGetStoreFiles,
	selectedStore,
}) {
	const [addOrEditModal, setAddOrEditModal] = useState(false);
	const [addOrEditModalType, setAddOrEditModalType] = useState(addOrEditModelAction.CREATE);
	const [allFiles, setAllFiles] = useState([]);

	const handleAddFile = (data) => {
		setAllFiles([...allFiles, data]);
	};

	console.log("lkjfjfjkdkjfldkjbflkjsabflkjsabfkjsad", filesDetails);
	const handleModalOpen = (type, row) => {
		setAddOrEditModalType(type);
		// setSelectedInsuranceDetail(row);
		setAddOrEditModal(true);
	};

	console.log("filesDetails", filesDetails);

	return (
		<Box display="flex" width="100%" flexWrap="wrap">
			<Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
				<Typography variant="button"> Uploaded Files Details</Typography>
				<Box>
					<Button
						size="small"
						variant="contained"
						// disabled={selectedStore.status === statusOptions.PUBLISHED.key}
						onClick={() => handleModalOpen(addOrEditModelAction.CREATE)}>
						Add
					</Button>
				</Box>
			</Box>
			<Divider sx={{ width: "100%" }} />
			<Box pt={1} width="100%">
				<DataGrid
					rows={filesDetails || []}
					columns={[
						...addFilesCol?.map((col) => converAttrToDatagridCol(col)),

						// {
						// 	headerName: "DELETE",
						// 	width: 150,
						// 	headerAlign: "center",
						// 	align: "center",

						// 	renderCell: (params) => {
						// 		return (
						// 			<Box display="flex" justifyContent="center" alignItems="center">
						// 				<IconButton
						// 					variant="contained"
						// 					color="error"
						// 					onClick={() => handleAgreementDelete(params.row)}>
						// 					<DeleteRounded />
						// 				</IconButton>
						// 			</Box>
						// 		);
						// 	},
						// },
					]}
					sx={{
						minHeight: 220,
						maxHeight: 300,
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							background: grey[300],
							// mb: 2,
							border: "none",
							borderRadius: 1,
							// padding: "10px 0px",
						},
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					disableAutosize
					onRowClick={({ row }) => handleModalOpen(addOrEditModelAction.UPDATE, row)}
					// disableRowSelectionOnClick
					pageSizeOptions={[5, 10]}
				/>
			</Box>

			{addOrEditModal && (
				<AddOrEditModal
					modal={addOrEditModal}
					setModal={setAddOrEditModal}
					setFilesDetails={setFilesDetails}
					handleFileUploadDetails={handleFileUploadDetails}
					createDetailsApi={createDetailsApi}
					handleGetStoreFiles={handleGetStoreFiles}
					selectedStore={selectedStore}
				/>
			)}
		</Box>
	);
}
export default FileUploadTable;
